export const getRandomInteger = (upperBound: number): number =>
  Math.floor(Math.random() * upperBound);
